import React from "react";
import { FiLogOut, FiUserCheck } from "react-icons/fi";
import { useImpersonation } from "../auth/impersonation";

const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, adminName, currentUserName, returnToAdmin } =
    useImpersonation();

  if (!isImpersonating) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        padding: "8px 16px",
        background: "var(--gradient-highlight)",
        color: "#241802",
        fontSize: "0.85rem",
        fontWeight: 700,
        flexWrap: "wrap",
      }}
    >
      <FiUserCheck size={16} />
      <span>
        Modo teste: você está vendo o sistema como <strong>{currentUserName}</strong>
        {adminName ? ` (sessão de ${adminName})` : ""}.
      </span>
      <button
        onClick={returnToAdmin}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "3px 12px",
          borderRadius: 999,
          border: "none",
          background: "#241802",
          color: "#fbbf24",
          fontWeight: 700,
          fontSize: "0.8rem",
          cursor: "pointer",
        }}
      >
        <FiLogOut size={14} /> Voltar para admin
      </button>
    </div>
  );
};

export default ImpersonationBanner;
